import { FC, createContext, useContext } from 'react';
import { Person } from '../../generated/graphql';

interface PersonFormContextProps {
  children?: React.ReactNode;
  person: Person | undefined | null;
}

interface PersonFormContext extends Omit<PersonFormContextProps, 'children'> {}

const PersonFormContext = createContext<PersonFormContext | null>(null);

export const usePersonFormContext = () => {
  const context = useContext(PersonFormContext);

  if (!context) {
    throw new Error('Make sure to use the PersonFormContext inside of the provider');
  }
  return context;
};

export const PersonFormContextProvider: FC<PersonFormContextProps> = ({ children, ...props }) => {
  return <PersonFormContext.Provider value={props}>{children}</PersonFormContext.Provider>;
};
